export const isEditor = Number(localStorage.getItem("rol")) > 0;
export const isAdmin = Number(localStorage.getItem("rol")) === 2;
export const currLang = localStorage.getItem("lang");
